// オプショナル支払請求のエンティティ
export class OptionalPayment {
  // オプショナルID DB型(*autokey)
  public optional_payment_id?: number;
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 金額 DB型(DOUBLE)
  public optional_amount?: any;
  // 日付 DB型(DATETIME)
  public optional_dt?: Date;
  // 備考 DB型(*varchar1024)
  public optional_note?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): OptionalPayment {
    const entity = new OptionalPayment();
    entity.optional_payment_id = record['optional_payment_id'];
    entity.user_id = record['user_id'];
    entity.optional_amount = record['optional_amount'];
    entity.optional_dt = record['optional_dt'];
    entity.optional_note = record['optional_note'];
    return entity;
  }
  static getTypeFitEntity(value: any): OptionalPayment {
    const entity = new OptionalPayment();
    entity.optional_payment_id = value.optional_payment_id;
    entity.user_id = value.user_id;
    entity.optional_amount = value.optional_amount;
    entity.optional_dt = value.optional_dt;
    entity.optional_note = value.optional_note;
    return entity;
  }
}
